import { render, staticRenderFns } from "./partner-payment-list.vue?vue&type=template&id=ff599ef6&"
import script from "./partner-payment-list.vue?vue&type=script&lang=js&"
export * from "./partner-payment-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports